import React from "react";
import { useSelector } from 'react-redux';
import { RecursiveVerticalMenu } from ".";

export default function CollapsibleMenu({ setIsMenuDrawerOpen }) {

    const menuAndPages = useSelector(state => state.reducerMenuAndPages.menuAndPages);

    return (
        <>
            {menuAndPages.map((item, i) => {
                return (
                    <RecursiveVerticalMenu item={item} setIsMenuDrawerOpen={setIsMenuDrawerOpen} />
                )
            }
            )}

        </>
    )
}

